import React, { useState } from 'react';
import Tensai from './Tensai';
import MenuButton from '../../components/MenuButton';

function SoloGameScreen({ onBackToMenu }) {
  const [gameFinished, setGameFinished] = useState(false);
  const [finalScore, setFinalScore] = useState(0);
  const [gameKey, setGameKey] = useState(0);

  const handleScore = (score) => {
    setFinalScore(score);
  };

  const handleGameEnd = () => {
    setGameFinished(true);
  };

  const handlePlayAgain = () => {
    setGameFinished(false);
    setFinalScore(0);
    setGameKey(prev => prev + 1); // Force remount of Tensai with new seed
  };

  return (
    <div className="solo-game-screen">
      <div className="fruitgame-container">
        {gameFinished ? (
          <div className="game-over-container">
            <h2>Game Over!</h2>
            <p className="final-score">Final Score: {finalScore}</p>
            <div className="game-over-buttons">
              <MenuButton onClick={handlePlayAgain}>Play Again</MenuButton>
              <MenuButton onClick={onBackToMenu}>Back to Main Menu</MenuButton>
            </div>
          </div>
        ) : (
          <div className="fruitbox-wrapper">
            <Tensai
              key={gameKey}
              rows={10}
              cols={17}
              seed={null}
              zenMode={false}
              onScore={handleScore}
              timerSeconds={120}
              autoStart={true}
            />
            <div className="solo-controls">
              <button className="control-button back-button" onClick={onBackToMenu}>
                Back to Main Menu
              </button>
              <button className="control-button end-button" onClick={handleGameEnd}>
                End Game
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SoloGameScreen;
